/**
 * Функція для відкриття маршруту до локації в Google Maps
 * @param city - Місто
 * @param street - Вулиця
 * @param buildingNumber - Номер будинку
 * @param _businessName - Назва бізнесу (опціонально, для контексту)
 */
export const openGoogleMaps = (
  city: string,
  street: string,
  buildingNumber: string,
  _businessName?: string
): void => {
  // Формуємо повну адресу
  const fullAddress = `${street} ${buildingNumber}, ${city}`;

  // Кодуємо адресу для URL
  const encodedAddress = encodeURIComponent(fullAddress);

  // Формуємо Google Maps URL з маршрутом
  // Використовуємо /dir/ для відкриття режиму маршруту (від поточної локації до пункту призначення)
  const mapsUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;

  // Відкриваємо в новій вкладці
  window.open(mapsUrl, "_blank");
};

/**
 * Альтернативна функція з використанням координат (якщо вони доступні)
 * @param latitude - Широта
 * @param longitude - Довгота
 * @param zoomLevel - Рівень масштабування (за замовчуванням 17)
 */
export const openGoogleMapsByCoordinates = (
  latitude: number,
  longitude: number,
  zoomLevel: number = 17
): void => {
  const mapsUrl = `https://www.google.com/maps/@${latitude},${longitude},${zoomLevel}z`;
  window.open(mapsUrl, "_blank");
};

/**
 * Функція для отримання прямого посилання на маршрут
 * @param city - Місто
 * @param street - Вулиця
 * @param buildingNumber - Номер будинку
 */
export const getGoogleMapsUrl = (
  city: string,
  street: string,
  buildingNumber: string
): string => {
  const fullAddress = `${street} ${buildingNumber}, ${city}`;
  const encodedAddress = encodeURIComponent(fullAddress);
  return `https://www.google.com/maps/dir/?api=1&destination=${encodedAddress}`;
};
